export const loadState = (initialState) => {
    try {
        const serializedState = sessionStorage.getItem('state');

        if (serializedState === null) {
            return initialState;
        }

        const savedState = JSON.parse(serializedState);
        // check if product id changed to load new product info when necessary
        if (savedState.product.id !== initialState.product.id) {
            return initialState;
        }
        return savedState;

    } catch (err) {
        return initialState;
    }
}

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    } catch (err) {
        // Ignore write errors.
    }
}
